import { Injectable } from '@angular/core';
import { FunctionsHelper } from '../helpers/functions';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { ReportFeature, ReportItem } from '../interfaces/reports.interface';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  selectedFeature: ReportFeature | null = null;

  constructor(
    private http: HttpClient,
    private _functionHelper: FunctionsHelper
  ) { }

  getReports(params: any): Promise<ReportItem[]> {
    return new Promise((resolve, reject) => {
      // this.http.get('/v4/products/reports/fetchAll')
      this.http.get('/v4/products/reports/fetchByDate', { params })
        .pipe(
          map((resp: any): ReportItem[] => {
            const reports: ReportItem[] = [];
            if (resp.statusCode === 200 && resp.result) {
              resp.result.map((report: any) => {
                reports.push(this.getReportObject(report));
              });
            }
            const sortedReports = _.orderBy(reports, ['createdAt'], ['asc']);
            return sortedReports;
          })
        ).subscribe({
          next: (response) => {
            resolve(response);
          },
          error: (err) => {
            console.error('ProductCollectionService:getReports()', err);
            reject(err);
          }
        });
    });
  }

  getReportObject = (report: any): ReportItem => {
    const itemsCount = report.count ? report.count : (report.count == 0 ? 0 : null);
    const finalItemsCount: number = Math.min(report.count, report.maxItems);

    const PRODUCT_COLLECTION = report?.reportStatus?.PRODUCT_COLLECTION || null;
    if (PRODUCT_COLLECTION) PRODUCT_COLLECTION.progressPercent = PRODUCT_COLLECTION.itemsProcessed / finalItemsCount;
    const PRODUCT_DETAILS_V2 = report?.reportStatus?.PRODUCT_DETAILS_V2 || null;
    if (PRODUCT_DETAILS_V2) PRODUCT_DETAILS_V2.progressPercent = PRODUCT_DETAILS_V2.itemsProcessed / finalItemsCount;
    const HISTORICAL_DATA = report?.reportStatus?.HISTORICAL_DATA || null;
    if (HISTORICAL_DATA) HISTORICAL_DATA.progressPercent = HISTORICAL_DATA.itemsProcessed / finalItemsCount;

    return {
      reportId: report.referenceId,
      reportName: report.reportName || report.referenceId,
      status: report.status,
      createdAt: report.created ? new Date(report.created) : new Date(),
      itemsCount,
      productsCollectionRequest: report.productsCollectionRequest || null,
      maxItems: report.maxItems || 0,
      reportStatus: {
        PRODUCT_COLLECTION,
        PRODUCT_DETAILS_V2,
        HISTORICAL_DATA,
      }
    };
  };

  getReportUrl = (reportId: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      this.http.get('/v4/products/reports/url/' + reportId)
        .subscribe({
          next: (resp: any) => {
            if (resp.statusCode === 200 && resp.result && resp.result.url) {
              resolve(resp.result.url);
            } else {
              reject('resp.result.url not found in ProductCollectionService:getReportUrl()');
            }
          },
          error: (err) => {
            console.error('ProductCollectionService:getReportUrl()', err);
            reject(err);
          }
        });
    });
  };

  downloadReport(url: string) {
    return this.http.get(url, {
      responseType: 'arraybuffer',
      headers: {
        'timeout': '120000'
      }
    }).pipe(
      map((file: ArrayBuffer) => {
        return file;
      })
    );
  }


  deleteReport(reportId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete('/v4/products/reports/delete', { params: { reportId } })
        .subscribe({
          next: (resp: any) => {
            if (resp.statusCode === 200 && resp.result && resp.result.status && resp.result.status === 'DELETED') {
              resolve(true);
            } else {
              resolve(false);
            }
          },
          error: (err) => {
            console.error('ProductCollectionService:deleteReport()', err);
            reject(err);
          }
        });
    });
  }

  updateReportName(reportId: string, reportName: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put('/v4/products/reports/updateReportName', null, { params: { reportId, reportName } })
        .subscribe({
          next: (resp: any) => {
            if (resp.statusCode === 200) {
              resolve(true);
            } else {
              resolve(false);
            }
          },
          error: (err) => {
            console.error('ProductCollectionService:updateReportName()', err);
            reject(err);
          }
        });
    });
  }
}
